import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Work", href: "#my-work" },
    { label: "Content", href: "#content-hub" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F5F0E8]/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.05)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className={`font-bebas text-2xl tracking-[0.15em] transition-colors duration-500 ${
            scrolled ? "text-[#1A1A1A]" : "text-white"
          }`}
        >
          ANKIT MOHANTY
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className={`font-inter text-xs tracking-[0.15em] uppercase transition-colors duration-300 ${
                scrolled
                  ? "text-[#6B6B6B] hover:text-[#1A1A1A]"
                  : "text-white/60 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, "#contact")}
            className={`font-inter text-xs tracking-[0.15em] uppercase px-5 py-2.5 border transition-all duration-300 ${
              scrolled
                ? "border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white"
                : "border-white/40 text-white hover:bg-white hover:text-[#1A1A1A]"
            }`}
          >
            Let's Create
          </a>
        </nav>

        <button
          className={`md:hidden p-2 transition-colors duration-300 ${
            scrolled ? "text-[#1A1A1A]" : "text-white"
          }`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-400 ${
          mobileMenuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-[#1A1A1A]/95 backdrop-blur-md px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="font-inter text-sm text-white/70 hover:text-white uppercase tracking-[0.15em] transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, "#contact")}
            className="font-inter text-xs uppercase tracking-[0.15em] px-5 py-3 border border-white/40 text-white text-center hover:bg-white hover:text-[#1A1A1A] transition-all duration-300"
          >
            Let's Create
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
